import React from 'react';
import { Link } from 'react-router-dom';

import { Grid, Typography } from '@material-ui/core';

import style from './styles.module.css';

import NotFound_IMG_V2 from 'asset/img/404-v2.svg';
import Logo from 'asset/img/authenticate_rgb.svg';

const NotFoundPage = () => {
    return (
        <Grid container className={style.container}>
            <img src={Logo} alt="Authenticate" className={style.logo} />
            <img src={NotFound_IMG_V2} alt="404: Not found" className={style._404_img} />
            <Typography className={style.text}>
                We can’t seem to find the page you are looking for.
            </Typography>
            <Link to="/" className={style.link}>
                Go Back
            </Link>
        </Grid>
    );
};

export default NotFoundPage;
